export default class Variable {
    constructor(method = '', title = '', value = '') {
        this.method = method;
        this.title = title;
        this.value = value;
    }
}
